export const haStatusType = {
  FUNCTIONAL: 'FUNCTIONAL',
  NON_FUNCTIONAL: 'NON_FUNCTIONAL',
  NOT_INSTALLED: 'NOT_INSTALLED',
} as const;

export type HaStatusType = (typeof haStatusType)[keyof typeof haStatusType];
